import { WorkflowCodeType, WorkflowComponentOutputType, WorkflowComponentParamType } from '../../types';
import { WorkflowComponent } from './workflowcomponent';
export const FILTER_TABLE_TRUE_NAME = 'match';
export const FILTER_TABLE_FALSE_NAME = 'unmatch';
// A component representing a filter, with two output tables (one with rows passing the filter,
// the other one with those that do not pass it)
export class FilterWorkflowComponent extends WorkflowComponent {
    constructor(metadata, inputs) {
        const outputs = [
            {
                name: FILTER_TABLE_TRUE_NAME,
                title: 'Matched',
                description: 'Table with rows that pass the filter',
                type: WorkflowComponentOutputType.Table
            },
            {
                name: FILTER_TABLE_FALSE_NAME,
                title: 'Unmatched',
                description: 'Table with rows that do not pass the filter',
                type: WorkflowComponentOutputType.Table
            }
        ];
        super(metadata, inputs, outputs);
    }
    async getCode({ workflow, params, connection, envVars, componentName, codeType, schemas }) {
        const tablenameMatch = connection.getOutputTableName(workflow.id, this.metadata.name, params, FILTER_TABLE_TRUE_NAME, codeType);
        const tablenameUnmatch = connection.getOutputTableName(workflow.id, this.metadata.name, params, FILTER_TABLE_FALSE_NAME, codeType);
        const preparedParams = this._prepareParameters(params);
        const match = await this._getMatchCode(preparedParams, envVars, workflow, componentName, connection, codeType, schemas?.output['match'] || undefined);
        const unmatch = await this._getUnmatchCode(preparedParams, tablenameMatch, envVars, workflow, componentName, connection, codeType, schemas?.output['unmatch'] || undefined);
        if (match === null || unmatch === null) {
            return null;
        }
        const queryMatch = connection.getCreateTempTableQuery(tablenameMatch, match, codeType, null);
        const unmatchIsUsed = workflow && componentName && codeType !== WorkflowCodeType.DryRun
            ? workflow.isTableUsed(componentName, FILTER_TABLE_FALSE_NAME)
            : true;
        const queryUnmatch = unmatchIsUsed
            ? connection.getCreateTempTableQuery(tablenameUnmatch, unmatch, codeType, null)
            : '';
        const query = `${queryMatch}\n${queryUnmatch}`;
        const sqlret = { query: query, outputs: {} };
        sqlret.outputs[FILTER_TABLE_TRUE_NAME] = tablenameMatch;
        sqlret.outputs[FILTER_TABLE_FALSE_NAME] = tablenameUnmatch;
        return sqlret;
    }
    getOutputTables({ workflow, params, connection, codeType }) {
        const tablenameMatch = connection.getOutputTableName(workflow.id, this.metadata.name, params, FILTER_TABLE_TRUE_NAME, codeType);
        const tablenameUnmatch = connection.getOutputTableName(workflow.id, this.metadata.name, params, FILTER_TABLE_FALSE_NAME, codeType);
        const outputs = {};
        outputs[FILTER_TABLE_TRUE_NAME] = tablenameMatch;
        outputs[FILTER_TABLE_FALSE_NAME] = tablenameUnmatch;
        return outputs;
    }
    canProvideOutputSchemas() {
        return true;
    }
    _getOutputSchemas({ workflow, params, schemas, connection, componentName }) {
        const tableInputName = this.inputs.find((input) => input.type === WorkflowComponentParamType.InputTable)?.name;
        const tablename = params[tableInputName];
        const columns = this._getSchemaForTablename(tablename, schemas, connection);
        if (columns == undefined) {
            return [];
        }
        const tablenameMatch = this._getDryRunOutputTableFqn(workflow, params, connection, componentName, FILTER_TABLE_TRUE_NAME);
        const tablenameUnmatch = this._getDryRunOutputTableFqn(workflow, params, connection, componentName, FILTER_TABLE_FALSE_NAME);
        return [
            {
                fqn: tablenameMatch,
                schema: columns
            },
            {
                fqn: tablenameUnmatch,
                schema: columns
            }
        ];
    }
    isOutputTableCreated(workflow, componentName, outputName, params) {
        if (outputName === FILTER_TABLE_TRUE_NAME) {
            return true;
        }
        if (outputName === FILTER_TABLE_FALSE_NAME) {
            const unmatchIsUsed = workflow && componentName
                ? workflow.isTableUsed(componentName, FILTER_TABLE_FALSE_NAME)
                : true;
            return unmatchIsUsed;
        }
        return false;
    }
}
